import { computed, ref } from 'vue'
import { signatureCampaignApi } from '@/services/api'
import type { TMySignatureCampaignDocument } from '@/services/signatureCampaign/interface'

const documents = ref<TMySignatureCampaignDocument[]>([])
const isLoading = ref(true)
let inFlight: Promise<TMySignatureCampaignDocument[]> | null = null

export const isCampaignDocumentSigned = (document: TMySignatureCampaignDocument) =>
  document.status === 'signed' || document.signatureDocument?.status === 'finished'

/**
 * Shared list of campaign documents waiting for the connected user.
 * The home widget and the global mandatory modal must see the same rows.
 */
export const useMySignatureCampaigns = () => {
  const load = async () => {
    if (inFlight) return inFlight

    isLoading.value = documents.value.length === 0
    inFlight = signatureCampaignApi.getMine().promise
      .then((rows) => {
        documents.value = rows || []
        return documents.value
      })
      .catch((error) => {
        console.error('Error fetching signature campaign documents:', error)
        return documents.value
      })
      .finally(() => {
        isLoading.value = false
        inFlight = null
      })

    return inFlight
  }

  const pendingMandatory = computed(() => documents.value.filter(document =>
    document.campaign?.isMandatory
    && !isCampaignDocumentSigned(document)
    && Boolean(document.signatureDocument?.procedureId),
  ))

  return {
    documents,
    isLoading,
    pendingMandatory,
    load,
    isCampaignDocumentSigned,
  }
}
